/**
 * Coups de pouce — Attendu 1074 « Reconnaitre une bissectrice ».
 *
 * reconnaitre_qcm_unique + reconnaitre_tableau_vf : entrée PARTAGÉE — les deux
 * vérifications (position, égalité codée ou écrite), jamais une seule ; le
 * codage fait foi. L'exemple (revue 2026-09-04) est le piège central du
 * format : allure de bissectrice, un seul codage. SVG pas à pas piloté par les
 * flèches de la sheet (data-etapes / data-caption).
 *
 * Sans coup de pouce (pur rappel) : vf_tableau_vf.
 */

const SVG_BISSECTRICE = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 360 250" width="100%" style="max-width:380px;height:auto;display:block" role="img" data-etapes="3"
     aria-label="Reconnaître une bissectrice, en 3 étapes à faire défiler avec les flèches. Un angle pOq, une demi-droite Om dessinée au milieu, un seul codage : l'arc de pOm porte un trait, l'arc de mOq n'en porte pas. Étape 2 : Om est entre Op et Oq, la position est bonne ; mais pOm est codé et mOq ne l'est pas, rien ne dit qu'ils sont égaux. Étape 3 : on ne peut pas l'affirmer, il manque l'égalité ; avec le même codage des deux côtés, ce serait oui. Position et égalité : il faut les deux">
  <style>
    @keyframes cp1074-pop { from { opacity: 0; } to { opacity: 1; } }
    .cp1074-pop { opacity: 0; animation: cp1074-pop 0.5s ease forwards; }
  </style>
  <!-- sous-titres : un par étape (exclusifs, pilotés par la sheet) -->
  <text x="8" y="21" font-size="12.5" font-weight="600" fill="#1E3A8A" opacity="1" data-caption="1" font-family="system-ui,sans-serif">[Om) est-elle la bissectrice de pÔq ?</text>
  <text x="8" y="21" font-size="12.5" font-weight="600" fill="#1E3A8A" opacity="0" data-caption="2" font-family="system-ui,sans-serif">Position : oui. Égalité codée : non</text>
  <text x="8" y="21" font-size="12.5" font-weight="600" fill="#B45309" opacity="0" data-caption="3" font-family="system-ui,sans-serif">Il manque l'égalité : on ne peut pas l'affirmer</text>

  <!-- ── La figure (étape 1) ─────────────────────────────────────────── -->
  <g data-etape="1" font-family="system-ui,sans-serif">
    <line x1="80.0" y1="152.0" x2="149.3" y2="142.3" stroke="#1E3A8A" stroke-width="2.2"/><text x="162.2" y="145.4" font-size="13" font-weight="700" fill="#1e293b" text-anchor="middle">p</text><line x1="80.0" y1="152.0" x2="77.6" y2="82.0" stroke="#1E3A8A" stroke-width="2.2"/><text x="77.1" y="74.1" font-size="13" font-weight="700" fill="#1e293b" text-anchor="middle">q</text><line x1="80.0" y1="152.0" x2="125.0" y2="98.4" stroke="#1E3A8A" stroke-width="2.2"/><text x="133.4" y="93.4" font-size="13" font-weight="700" fill="#1e293b" text-anchor="middle">m</text>
    <path d="M 103.8 148.7 A 24 24 0 0 0 95.4 133.6" fill="none" stroke="#B45309" stroke-width="1.6"/>
    <line x1="96.6" y1="142.8" x2="105.4" y2="137.9" stroke="#B45309" stroke-width="2"/>
    <circle cx="80.0" cy="152.0" r="2.6" fill="#1e293b"/>
    <text x="69.7" y="169.3" font-size="13" font-weight="700" fill="#1e293b" text-anchor="middle">O</text>
  </g>

  <!-- ── Les deux vérifications (étape 2) ────────────────────────────── -->
  <g data-etape="2" data-anim="1" font-family="system-ui,sans-serif">
    <g class="cp1074-pop">
      <path d="M 135.5 144.2 A 56 56 0 0 0 78.0 96.0" fill="none" stroke="#1D9E75" stroke-width="2" stroke-dasharray="5 3"/>
      <text x="184" y="66" font-size="11.5" font-weight="700" fill="#1D9E75">Position : [Om) est entre</text>
      <text x="184" y="81" font-size="11.5" font-weight="700" fill="#1D9E75">[Op) et [Oq) ✓</text>
      <text x="184" y="106" font-size="11.5" font-weight="700" fill="#B45309">Égalité : pÔm est codé,</text>
      <text x="184" y="121" font-size="11.5" font-weight="700" fill="#B45309">mÔq ne l'est pas ✗</text>
      <text x="184" y="137" font-size="11" font-weight="600" fill="#B45309">(rien ne dit qu'ils sont</text>
      <text x="184" y="150" font-size="11" font-weight="600" fill="#B45309">égaux, même si le dessin</text>
      <text x="184" y="163" font-size="11" font-weight="600" fill="#B45309">a l'air symétrique)</text>
    </g>
  </g>

  <!-- ── Conclusion et geste inverse (étape 3) ───────────────────────── -->
  <g data-etape="3" data-anim="1" font-family="system-ui,sans-serif">
    <g class="cp1074-pop">
      <text x="184" y="184" font-size="11.5" font-weight="800" fill="#B45309">On ne peut pas conclure :</text>
      <text x="184" y="199" font-size="11.5" font-weight="800" fill="#B45309">il manque l'égalité.</text>
      <path d="M 95.4 133.6 A 24 24 0 0 0 79.2 128.0" fill="none" stroke="#1D9E75" stroke-width="1.8" stroke-dasharray="3 2"/>
      <line x1="86.2" y1="134.0" x2="89.4" y2="124.6" stroke="#1D9E75" stroke-width="2.4" stroke-dasharray="3 2"/>
      <text x="184" y="218" font-size="11.5" font-weight="700" fill="#1D9E75">Même codage des deux</text>
      <text x="184" y="232" font-size="11.5" font-weight="700" fill="#1D9E75">côtés : alors oui ✓</text>
      <text x="180" y="246" font-size="12" font-weight="800" fill="#1E3A8A" text-anchor="middle">Position ET égalité : il faut les deux.</text>
    </g>
  </g>

  <text x="180" y="246" font-size="11" font-weight="700" fill="#b45309" text-anchor="middle" opacity="0" data-caption="1" font-family="system-ui,sans-serif">↓ Touche les flèches pour avancer, étape par étape ↓</text>
</svg>`.trim();

const AIDE_RECONNAITRE = {
    pages: [
        {
            titre: 'La règle',
            lignes: [
                "**La bissectrice d'un angle, c'est deux choses à la fois** : une demi-droite issue du sommet, à l'intérieur de l'angle, et qui le partage en deux angles de même mesure.",
                "**Vérifie d'abord la position** : la demi-droite est-elle entre les deux côtés de l'angle ?",
                "**Vérifie ensuite l'égalité** : les deux angles sont-ils codés par la même marque, ou ont-ils la même mesure écrite ?",
                "**Il faut les deux.** Une demi-droite extérieure n'est jamais la bissectrice, même si l'angle qu'elle forme vaut la moitié. Une demi-droite intérieure sans égalité codée ou écrite ne prouve rien.",
                '**Le codage fait foi** : on ne mesure pas au rapporteur.',
            ],
        },
        { titre: 'Un exemple', svg: SVG_BISSECTRICE },
    ],
};

const CP_1074 = {
    reconnaitre_qcm_unique: AIDE_RECONNAITRE,
    reconnaitre_tableau_vf: AIDE_RECONNAITRE,
};

export default CP_1074;
